import { Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { ScrollAnchorService } from './scroll-anchor.service';
import { Subject, takeUntil, tap } from 'rxjs';

@Directive({
  selector: '[prlwScrollAnchorMenu]',
  standalone: true,
})
export class ScrollAnchorMenuDirective implements OnDestroy {
  @Input() prlwScrollAnchorMenu: string = 'foo';

  private readonly destroy$ = new Subject<void>();
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get anchor() {
    return `${this.prlwScrollAnchorMenu}Anchor`;
  }

  constructor(
    private readonly scrollAnchorService: ScrollAnchorService,
    private readonly el: ElementRef,
  ) {
    scrollAnchorService.intersectionAnchor$
      .pipe(
        tap((intersectionAnchor) => {
          if (intersectionAnchor === this.anchor) {
            this.scrollIntoView();
          }
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  scrollIntoView() {
    (this.el.nativeElement as HTMLElement).scrollIntoView({ block: 'nearest' });
  }
}
